import { render, staticRenderFns } from "./step-contacts-location-city.vue?vue&type=template&id=6d240f35"
import script from "./step-contacts-location-city.vue?vue&type=script&lang=ts"
export * from "./step-contacts-location-city.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports